import React from 'react';
import PropTypes from 'prop-types';

function ContentButtons({
  buttons
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "slds-grid"
  }, buttons.map((btn, i) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement("div", {
    key: i,
    className: "slds-m-right_xx-small"
  }, btn)));
}
ContentButtons.displayName = "ContentButtons";
const {
  arrayOf,
  node
} = PropTypes;
ContentButtons.propTypes = {
  buttons: arrayOf(node).isRequired
};

export { ContentButtons as default };
